import React, { useState } from 'react';
import { Inbox, CheckCircle, XCircle, Play, TrendingUp, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

export const DecisionInbox: React.FC = () => {
  const [decisions, setDecisions] = useState([
    {
      id: '1',
      title: 'Aprovar novo lote de vídeos',
      description: 'A IA identificou fadiga nos anúncios de vídeo e gerou 5 novas variações baseadas nos B-Rolls enviados. Deseja aprovar a veiculação?',
      type: 'criativo',
      impact: 'Alto impacto no CTR',
      status: 'pendente'
    },
    {
      id: '2',
      title: 'Aumentar orçamento Meta Ads',
      description: 'A campanha "Pacientes Particulares" está com CPA 15% abaixo do teto estabelecido. Sugerimos escalar o orçamento de R$ 150/dia para R$ 250/dia.',
      type: 'orcamento',
      impact: 'Escala de resultados',
      status: 'pendente'
    }
  ]);

  const handleDecision = (id: string, approved: boolean) => {
    setDecisions(prev => prev.filter(d => d.id !== id));
    toast.success(approved ? 'Decisão aprovada! A IA já está executando.' : 'Sugestão recusada. A IA buscará alternativas.');
  };

  if (decisions.length === 0) {
    return (
      <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm text-center">
        <div className="w-16 h-16 bg-gray-50 text-gray-400 flex items-center justify-center rounded-2xl mx-auto mb-4 border border-gray-100">
          <CheckCircle size={32} />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">Tudo em dia!</h3>
        <p className="text-sm text-gray-500 max-w-md mx-auto">Não há novas decisões pendentes. A IA está monitorando e avisará quando precisar de sua aprovação.</p>
      </div>
    );
  }

  return (
    <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-indigo-50 text-indigo-600 flex items-center justify-center rounded-xl">
          <Inbox size={20} />
        </div>
        <div>
          <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
            Inbox de Decisões
            <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-0.5 rounded-full">{decisions.length}</span>
          </h3>
          <p className="text-sm text-gray-500">Aprovações estratégicas recomendadas pela IA.</p>
        </div>
      </div>

      <div className="space-y-4">
        {decisions.map(decision => (
          <div key={decision.id} className="p-5 rounded-xl border border-gray-200 bg-white shadow-sm hover:border-indigo-300 transition-colors">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <h4 className="font-semibold text-gray-900">{decision.title}</h4>
                  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase ${
                    decision.type === 'criativo' ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-700'
                  }`}>
                    {decision.type === 'criativo' ? 'Criativos' : 'Orçamento'}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-4">{decision.description}</p>
                <div className="flex items-center gap-1 text-xs font-medium text-amber-600 bg-amber-50 px-2.5 py-1 rounded-md w-fit">
                  <AlertCircle size={14} />
                  {decision.impact}
                </div>
              </div>
              <div className="flex flex-col gap-2 shrink-0">
                <button 
                  onClick={() => handleDecision(decision.id, true)}
                  className="flex items-center justify-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors"
                >
                  <CheckCircle size={16} />
                  Aprovar
                </button>
                <button 
                  onClick={() => handleDecision(decision.id, false)}
                  className="flex items-center justify-center gap-2 px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 border border-gray-200 text-sm font-medium rounded-lg transition-colors"
                >
                  <XCircle size={16} />
                  Recusar
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
